import api from '@/services/api'

const downloadFeedbacksTemplate = async () => {
    try {
        return await api.get('/feedbacks/template-export', {
            responseType: 'arraybuffer',
        })
    } catch (e) {
        console.log(e)
    }
}

const uploadToApi = async (file) => {
    try {
        return await api.post('/feedbacks/upload', {
            file,
        })
    } catch (e) {
        console.log(e)
    }
}

export { uploadToApi, downloadFeedbacksTemplate }
